import { render } from "./RepresentanteFormPage.vue?vue&type=template&id=50b5e2de&scoped=true"
import script from "./RepresentanteFormPage.vue?vue&type=script&lang=js"
export * from "./RepresentanteFormPage.vue?vue&type=script&lang=js"

import "./RepresentanteFormPage.vue?vue&type=style&index=0&id=50b5e2de&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Repository\\C318-CAF. Portal de Juntas telematicas\\CAF-Solution\\NetCoreWebApi\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b5e2de"]])

export default __exports__